
















































import { ImportApi } from '@/api/import';
import { PartnerPracticeType } from '@/shared/types/partner-practice-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');

const importApi = new ImportApi();

@Component
export default class AddDataImportDialog extends Vue {
    @typesModule.Getter('activePartnerPracticeTypesForCurrentUser') private partnerPracticeTypes!: Array<PartnerPracticeType>;
    @Prop({ required: true }) private visible!: boolean;

    private isVisible: boolean = this.visible;
    private isBusy: boolean = false;
    private dataImportFile: File | null = null;
    private selectedType: number | null = null;
    private selectedPartnerPracticeId: string | null = null;

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    private async onImportFileAsync(): Promise<void> {
        if (!(await this.$validator.validateAll('data-import-file'))) {
            return;
        }

        this.isBusy = true;

        try {
            await importApi.uploadDataImportFileAsync(this.dataImportFile!, {
                type: this.selectedType!,
                partnerPracticeId: this.selectedPartnerPracticeId!,
            });

            this.$emit('ok', this.dataImportFile!.name);
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not upload the data import file '${this.dataImportFile!.name}'. Please try again.`, type: 'is-danger' });
            }
        }

        this.isBusy = false;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }
}
